<template>
  <div
    ref="kt_editar_inutilizacao_nfe_modal"
    data-bs-backdrop="static"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_editar_inutilizacao_nfe_modal"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="card-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/general/gen005.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Editar inutilização</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-5" v-if="this.loading === false">
          <div
            v-if="this.errosGerais && this.errosGerais.Message"
            class="notice d-flex bg-light-danger rounded border-danger border border-dashed ms-0 me-0 mb-9 p-6"
          >
            <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
              <inline-svg src="media/icons/duotune/general/gen044.svg" />
            </span>
            <div class="d-flex flex-stack flex-grow-1">
              <div class="fw-bold">
                <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                <div class="fs-6 text-gray-600">
                  {{ this.errosGerais.Message }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-6"
            >
              <label class="form-label">Ano</label>
              <input
                type="text"
                :class="[
                  'form-control mb-2',
                  errosValidacao['ano'] ? 'is-invalid' : '',
                ]"
                v-model="this.refInutilizacaoNFe.ano"
                maxlength="2"
                id="txtAno"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["ano"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-6"
            >
              <label class="form-label">Modelo</label>
              <input
                type="text"
                :class="[
                  'form-control mb-2',
                  errosValidacao['modelo'] ? 'is-invalid' : '',
                ]"
                v-model="this.refInutilizacaoNFe.modelo"
                maxlength="2"
                id="txtModelo"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["modelo"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-6"
            >
              <label class="form-label">Série</label>
              <input
                type="text"
                :class="[
                  'form-control mb-2',
                  errosValidacao['serie'] ? 'is-invalid' : '',
                ]"
                v-model="this.refInutilizacaoNFe.serie"
                maxlength="3"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["serie"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Nº Nota Inicial</label>
              <input
                type="text"
                :class="[
                  'form-control mb-2',
                  errosValidacao['n_nf_ini'] ? 'is-invalid' : '',
                ]"
                v-model="this.refInutilizacaoNFe.n_nf_ini"
                maxlength="9"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["n_nf_ini"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Nº Nota Final</label>
              <input
                type="text"
                :class="[
                  'form-control mb-2',
                  errosValidacao['n_nf_fin'] ? 'is-invalid' : '',
                ]"
                v-model="this.refInutilizacaoNFe.n_nf_fin"
                maxlength="9"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["n_nf_fin"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 fv-row mb-6"
            >
              <label class="form-label">Justificativa</label>
              <input
                type="text"
                :class="[
                  'form-control mb-2',
                  errosValidacao['justificativa'] ? 'is-invalid' : '',
                ]"
                v-model="this.refInutilizacaoNFe.justificativa"
                maxlength="255"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["justificativa"] }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body p-5" v-else>
          <div
            class="ms-7 mb-7"
            v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              Aguarde, carregando...
              <span
                class="spinner-border spinner-border-sm align-middle ms-2"
              ></span>
            </span>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            @click="confirmar()"
            v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loading">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

const inutilizacaoNFeInicializado = {
  ano: "",
  modalo: "",
  serie: "",
  n_nf_ini: 0,
  n_nf_fin: 0,
  justificativa: "",
};

export default {
  emits: [
    "exibirEditarInutilizacaoNFeModal",
    "confirmarEditarInutilizacaoNFeModal",
  ],
  props: {
    refInutilizacaoNFeEdicao: { type: Object, required: false },
    id: { type: Number, required: true, default: -1 },
  },
  methods: {
    async confirmar() {
      this.errosValidacao = {};
      this.loading = true;

      if (this.validar() === true) {
        if (this.id === -1) {
          try {
            let formData = this.$utils.convertModelToFormData(
              this.refInutilizacaoNFe
            );

            let retPost = await this.$store.dispatch(
              "inutilizacaoNFe/postInutilizacaoNFe",
              formData
            );
            if (retPost.Success === true) {
              hideModal(this.$refs.kt_editar_inutilizacao_nfe_modal);
              this.$emit("confirmarEditarInutilizacaoNFeModal");
              this.$emit("exibirEditarInutilizacaoNFeModal", false);
            }
          } catch (error) {
            this.errosGerais = error;
            this.errosValidacao = error;
          }
        } else {
          try {
            let formData = this.$utils.convertModelToFormData(
              this.refInutilizacaoNFe
            );

            let retPut = await this.$store.dispatch(
              "inutilizacaoNFe/putInutilizacaoNFe",
              formData
            );
            if (retPut.Success === true) {
              hideModal(this.$refs.kt_editar_inutilizacao_nfe_modal);
              this.$emit("confirmarEditarInutilizacaoNFeModal");
              this.$emit("exibirEditarInutilizacaoNFeModal", false);
            }
          } catch (error) {
            this.errosGerais = error;
            this.errosValidacao = error;
          }
        }
      } else {
        Swal.fire({
          text: "Verifique os avisos!",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn fw-bold btn-warning",
          },
        });
      }

      this.loading = false;
    },
    validar() {
      let result = true;

      if (!this.refInutilizacaoNFe.ano) {
        this.errosValidacao.ano = "Informe o ano";
        result = false;
      } else if (this.refInutilizacaoNFe.ano.trim().length <= 0) {
        this.errosValidacao.ano = "Informe o ano";
        result = false;
      }

      if (!this.refInutilizacaoNFe.modelo) {
        this.errosValidacao.modelo = "Informe o modelo";
        result = false;
      } else if (this.refInutilizacaoNFe.modelo.trim().length <= 0) {
        this.errosValidacao.ano = "Informe o modelo";
        result = false;
      }

      if (!this.refInutilizacaoNFe.serie) {
        this.errosValidacao.serie = "Informe a série";
        result = false;
      } else if (this.refInutilizacaoNFe.serie.trim().length <= 0) {
        this.errosValidacao.ano = "Informe a série";
        result = false;
      }

      if (!this.refInutilizacaoNFe.n_nf_ini) {
        this.errosValidacao.n_nf_ini =
          "Informe o número inicial da nota a ser inutilizada";
        result = false;
      } else if (this.refInutilizacaoNFe.n_nf_ini.trim().length <= 0) {
        this.errosValidacao.n_nf_ini =
          "Informe o número inicial da nota a ser inutilizada";
        result = false;
      }

      if (!this.refInutilizacaoNFe.n_nf_fin) {
        this.errosValidacao.n_nf_fin =
          "Informe o número final da nota a ser inutilizada";
        result = false;
      } else if (this.refInutilizacaoNFe.n_nf_fin.trim().length <= 0) {
        this.errosValidacao.n_nf_fin =
          "Informe o número final da nota a ser inutilizada";
        result = false;
      }

      if (!this.refInutilizacaoNFe.justificativa) {
        this.errosValidacao.justificativa = "Informe a justificativa";
        result = false;
      } else if (this.refInutilizacaoNFe.justificativa.trim().length <= 0) {
        this.errosValidacao.justificativa = "Informe a justificativa";
        result = false;
      } else if (this.refInutilizacaoNFe.justificativa.trim().length < 15) {
        this.errosValidacao.justificativa =
          "A justificativa deve ter no mínimo 15 caracteres";
        result = false;
      }

      return result;
    },
    cancelar() {
      hideModal(this.$refs.kt_editar_inutilizacao_nfe_modal);
      this.$emit("exibirEditarInutilizacaoNFeModal", false);
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
  },
  async mounted() {
    if (this.id >= 0) {
      try {
        this.loading = true;
        let ret = await this.$store.dispatch(
          "inutilizacaoNFe/getInutilizacaoNFe",
          this.id
        );

        if (ret.Success === true) {
          this.refInutilizacaoNFe = ret.Data;
        }
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    } else {
      if (
        this.refInutilizacaoNFeEdicao &&
        this.refInutilizacaoNFeEdicao !== null &&
        this.refInutilizacaoNFeEdicao.ano !== ""
      ) {
        this.refInutilizacaoNFe = JSON.parse(
          JSON.stringify(this.refInutilizacaoNFeEdicao)
        );
      } else {
        this.refInutilizacaoNFe = JSON.parse(
          JSON.stringify(inutilizacaoNFeInicializado)
        );
      }
    }
    this.errosValidacao = {};

    setTimeout(() => {
      this.nextFocus("txtAno");
    }, 800);
  },
  data() {
    return {
      errosValidacao: [],
      errosGerais: [],
      loading: false,
      refInutilizacaoNFe: {},
    };
  },
};
</script>

<style>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  background-color: #00000042;
}
</style>
